import React, { useMemo } from 'react';

// 20 floating gold particles randomly distributed in hero
export const FloatingParticles = ({ count = 20 }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map(() => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 1 + Math.random() * 3,
        opacity: 0.1 + Math.random() * 0.45,
        duration: 4 + Math.random() * 7,
        delay: Math.random() * 5,
      })),
    [count],
  );

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {particles.map((p, i) => (
        <span
          key={i}
          className="float-particle absolute rounded-full bg-[#C9A84C]"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
};
